import { configs } from '@/configs';

export const NETWORK_CHAIN_ID = configs.networkChainId;